import Enumerator from '../global/Enumerator';

export const contactEmploymentPriorities = [
  'none',
  'primary_employment',
  'secondary_employment'
];

export class ContactEmploymentPriority extends Enumerator {
  static default() {
    return this.of('primary_employment');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'primary_employment';
        break;
      case '2':
        correctOption = 'secondary_employment';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

ContactEmploymentPriority.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  primary_employment: {
    get title() {
      return 'Primary employment';
    }
  },
  secondary_employment: {
    get title() {
      return 'Secondary employment';
    }
  }
});

export default {
  contactEmploymentPriorities,
  ContactEmploymentPriority
};
